import { Component, Input } from '@angular/core';

export enum Button {
  Primary,
  Secondary,
  Red,
}

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent {
  @Input() outline: boolean = false;
  @Input() buttonStyle: Button = Button.Primary;
  @Input() disabled: boolean = false;
  @Input() block: boolean = false;
  @Input() buttonType: string = 'button';

  constructor() {}

  get buttonClass() {
    let btnClassArray = [];

    if (this.outline) {
      btnClassArray.push('outline');
    }

    if (this.block) {
      btnClassArray.push('block');
    }

    if (this.buttonStyle === Button.Secondary) {
      btnClassArray.push('button-secondary');
    }

    if (this.buttonStyle === Button.Red) {
      btnClassArray.push('button-red');
    }

    if (this.buttonStyle === Button.Primary) {
      btnClassArray.push('button-primary');
    }

    return btnClassArray.join(' ');
  }
}
